<template>
    <v-card outlined class="card-session" :elevation="elevation ? elevation : 1" rounded="lg">
        <v-card-title class="d-flex justify-space-between align-center">
            <span> {{ title }} </span>
            <v-icon class="card-icon" :style="{ color: color || 'inherit' }"> {{ icon }} </v-icon>
        </v-card-title>
        <v-card-text>
            <div class="value" :style="{ color: color || 'inherit' }"> {{ value }} </div>
            <div class="description"> {{ description }} </div>
        </v-card-text>
        <div v-if="bottomline" class="bottom-line" :style="{ backgroundColor: color || 'inherit' }"></div>
    </v-card>
</template>
<script>

//import { eventHub } from "@/main";

export default {
    name: "CardItem",

    props: ["bottomline", "elevation", "color", "icon", "title", "description", "value"],

    //methods: {
    //},
};

</script>

<style lang="scss" scoped>
.card-icon {
    background-color: var(--v-lightGray-base);
    border-radius: 20%;
    padding: 8px;
}

.value {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
}

.description {
    font-size: 14px;
    color: var(--v-mediumGray-base);
}

.card-session {
    position: relative;
    overflow: hidden;
}

.bottom-line {
    height: 4px; /* Altura da linha */
    width: 110%; /* Largura da linha */
    position: absolute;
    bottom: 0;
    left: 0;
}
</style>